import { fitTitle, fitDescription } from "@/lib/seo-text";
import { createFileRoute } from "@tanstack/react-router";

import { LocationPage } from "@/components/location-page";
import { faqSchema, localBusinessSchema } from "@/lib/firm";
import { BRISBANE } from "@/lib/locations/brisbane";

export const Route = createFileRoute("/conveyancing-brisbane")({
  head: () => ({
    meta: [
      { title: fitTitle(BRISBANE.metaTitle) },
      { name: "description", content: fitDescription(BRISBANE.description) },
      { property: "og:title", content: fitTitle(BRISBANE.metaTitle) },
      { property: "og:description", content: fitDescription(BRISBANE.description) },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://coastsidelaw.com.au/conveyancing-brisbane" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://coastsidelaw.com.au/conveyancing-brisbane" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(faqSchema(BRISBANE.faqs)) },
      { type: "application/ld+json", children: JSON.stringify(localBusinessSchema) },
    ],
  }),
  component: () => <LocationPage content={BRISBANE} />,
});
